import { Injectable } from "@angular/core";
import { GridService } from 'app/_services/grid.service';
import { IHeader } from "app/_models/IHeader";
import { AppComponent } from "app/app.component";
import { ILine } from "app/_models/ILine";
import { IFilter } from "app/_models/IFilter";
import { ISettings } from "app/_models/ISettings";
import { FilterController } from "./filterController";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { IRowValues } from "app/_models/IRowValues";

@Injectable({ providedIn: 'root' })
export class GridController {
  constructor(
    private app: AppComponent,
    private gridService: GridService,
    private filterController: FilterController,
    private sanitizer: DomSanitizer    
  ) { }

  formatSanitise(lines: ILine[], headers: IHeader[], filters: IFilter[], dateFormat: string, nodeId: string, viewName: string, directModeEnabled?: boolean): { lines: ILine[], headers: IHeader[], filters: IFilter[] } {
    headers.forEach(header => {
      header.kind = 'IHeader';
      if (header.dataType == 'Byte[]' ) header.displayFormat = 'IMAGE';
      if (header.dataType == 'HTML') header.displayFormat = 'HTML';

      header.sortedBy = false;
      if (viewName == 'master' && localStorage.getItem(`qx_sort_${nodeId}`) && !directModeEnabled) {        
        let sortHeader = JSON.parse(localStorage.getItem(`qx_sort_${nodeId}`)).header;        
        if (sortHeader.field == header.field) header.sortedBy = true;
      } else if (viewName == 'master' && sessionStorage.getItem(`qx_sort_${nodeId}`) && directModeEnabled) {
        let sortHeader = JSON.parse(sessionStorage.getItem(`qx_sort_${nodeId}`)).header
        if (sortHeader.field == header.field) header.sortedBy = true;
      } else if (localStorage.getItem(`qx_sort_${nodeId}_${viewName}`)) {
        let sortHeader = JSON.parse(localStorage.getItem(`qx_sort_${nodeId}_${viewName}`)).header;        
        if (sortHeader.field == header.field) header.sortedBy = true;
      }
    })

    filters.forEach(filter => {
      let header = headers.find(header => header.field == filter.field);
      if (header) header.displayFormat = filter.displayFormat;
      if (header && header.dataType == 'HTML') header.displayFormat = 'HTML';
    })

    let lineNumber = 1;
    lines.forEach(line => {
      line.kind = 'ILine';
      for (let key in line.list) {
        if (line.list[key] && (line.list[key].toString().toLowerCase() === 'true' || line.list[key].toString().toLowerCase() === 'false' || line.list[key].length == 0)) {
          line.list[key] = this.app.tryParseBoolean(line.list[key]);
          headers.forEach(header => {
            if (header.caption == key) header.displayFormat = 'CHECK';
          })
        }  
        
        //line.list[key] comes back in server date format which is usually mm[0]/dd[1]/yyyy[2]
        let header = headers.find(header => header.caption == key);                  
        if(line.list[key] && line.list[key] != null && header && header.displayFormat && (header.displayFormat == 'DATE' || header.displayFormat == 'DATETIME')) {                                        
          if (line.list[key]) {
            let dateValues = line.list[key].toString().split('/');
            
            if (dateFormat == 'dd/MM/yyyy') {
              line.list[key] = `${dateValues[1]}/${dateValues[0]}/${dateValues[2]}` as any;
            }

            if (dateFormat == 'yyyy/MM/dd') {
              if (dateValues[2].includes(':')) {
                let timeValues = dateValues[2].split(' ');
                line.list[key] = `${timeValues[0]}/${dateValues[0]}/${dateValues[1]} ${timeValues[1]}` as any;
              } else {
                line.list[key] = `${dateValues[2]}/${dateValues[0]}/${dateValues[1]}` as any;
              }
            }
          }          
        } else if (header && header.displayFormat == 'HTML') {
          if (line.list[key]) {
            line.list[key] = this.getSafeHtml(line.list[key]);
          }
        }   
      }
      
      line.lineNumber = lineNumber;
      lineNumber++;
    })

    filters = this.checkHeaderFilters(headers, filters);
    return { lines, headers, filters };
  }

  getSafeHtml(value: IRowValues): SafeHtml {
    let cleaned = value.replace('<br><br>', '');
    if (cleaned.startsWith('<a', 0)) {
      cleaned = cleaned.replace('<a', '<a target="_blank" rel="noopener" onclick="event.stopPropagation();"');
    }
    return this.sanitizer.bypassSecurityTrustHtml(cleaned);
  }

  saveLayout(nodeId: string, viewName: string, username: string, headers: IHeader[]): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      let keys = ['nodeId', 'viewName', 'username', 'columns'];
      let values = [nodeId, viewName, username, JSON.stringify(headers)];
      let formData = this.app.buildForm(keys, values);

      this.gridService.saveGridLayout(formData).subscribe({
        error: (errorLog) => { console.log(errorLog.error); }
      });

      resolve(true);
    });
  }  

  checkHeaderFilters(headers: IHeader[], filters: IFilter[]): IFilter[] {    
    if (headers.length > filters.length) {      
      headers.forEach(header => {
        if (header.visible) {
          let filter = filters.find(filter => filter.field == header.field);
          if (!filter) filters.push(this.filterController.createFilter(header));          
        }        
      })
    }  
    
    if (headers.filter(header => header.visible).length < filters.length) {    
      filters.forEach(filter => {
        let header = headers.find(header => header.field == filter.field);
        if (!header) {
          let filterIndex = filters.findIndex(f => f.field == filter.field);
          if (filterIndex > -1) filters.splice(filterIndex, 1);
        }
      })      
    }       
        
    return filters;
  }

  handleGridError(error: any, nodeId: string, viewName: string, rowId: string, settings: ISettings): void {
    this.app.hideLoader();
    console.log(error);

    if (localStorage.getItem(`qx_filters_advanced_${nodeId}`))
      localStorage.removeItem(`qx_filters_advanced_${nodeId}`);   

    if (localStorage.getItem(`qx_filters_${nodeId}`))
      localStorage.removeItem(`qx_filters_${nodeId}`);

    if (localStorage.getItem(`qx_filters_advanced_${nodeId}_${viewName}`))
      localStorage.removeItem(`qx_filters_advanced_${nodeId}_${viewName}`);   

    if (!settings.detailFiltersByRowSetting && localStorage.getItem(`qx_filters_${nodeId}_${viewName}`))
      localStorage.removeItem(`qx_filters_${nodeId}_${viewName}`);

    if (settings.detailFiltersByRowSetting && localStorage.getItem(`qx_filters_${nodeId}_${viewName}_${rowId}`))
      localStorage.removeItem(`qx_filters_${nodeId}_${viewName}_${rowId}`);

    if (settings.detailedErrorSetting) {
      sessionStorage.setItem('errorDetails', JSON.stringify(error.error));
      this.app.router.navigate(["error"]);
      return;
    }

    this.app.alertError(`An error occured Ref: ${error.error.refNumber}`);
    return;
  }
}